import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  Box,
  Input,
  Stack
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { isMobile } from 'utils/helpers'
import { COLORS } from 'utils/styles'

const MotionStack = motion(Stack)

export const Affinities = ({
  chooseAffi,
  affinitiesArray,
  setAffinitiesArray,
  affinityList
}) => {
  const [affinitiesInput, setAffinitiesInput] = useState('')
  const [displayVal, setDisplayVal] = useState('none')
  const affinitiesListRef = useRef(null)
  const inputRef = useRef(null)

  const manageHeight = () => {
    if (chooseAffi) {
      if (isMobile()) {
        return '18svh'
      }

      return '15em'
    }

    return '0px'
  }

  const filterAffinityList = (affinities = affinityList) => affinities.map((item) => (
    <Box
      onClick={() => setAffinitiesArray([{ id: item.id, title: item.title }])}
      p="3px 6px"
      cursor="pointer"
      borderRadius="5px"
      bg={COLORS.gold}
      width="max-content"
      alignItems="center"
      name={item.title}
      fontSize="13px"
    >
      {item.title}
    </Box>
  ))

  const [filteredAffinityList, setFilteredAffinityList] = useState(filterAffinityList())

  useEffect(() => {
    let affinityListTemp = affinityList
    const tempAffinitiesInput = affinitiesInput.toLowerCase()

    if (affinitiesInput !== '') {
      affinityListTemp = affinityListTemp.filter((item) => {
        const title = item.title.toLowerCase()

        return tempAffinitiesInput === title.substring(0, tempAffinitiesInput.length)
      })
    }

    setFilteredAffinityList(filterAffinityList(affinityListTemp))
  }, [affinitiesInput, affinitiesArray])

  return (
    <MotionStack
      initial={false}
      animate={{ maxHeight: manageHeight() }}
      onAnimationStart={() => {
        if (
          displayVal === 'none'
          && chooseAffi
        ) {
          setDisplayVal('flex')
        }
      }}
      onAnimationComplete={() => {
        if (
          displayVal === 'flex'
          && !chooseAffi
        ) {
          setDisplayVal('none')
        }
      }}
      transition={{
        type: 'tween',
        duration: 0.8
      }}
      overflow="hidden"
      direction="column"
      spacing="1rem 10px"
      display={displayVal}
      position="absolute"
      zIndex={2}
    >
      <Box
        display="flex"
        justifyContent="center"
      >
        <Input
          ref={inputRef}
          placeholder="Tag your article with one affinity"
          value={affinitiesInput}
          onChange={(e) => setAffinitiesInput(e.target.value)}
          name="profile_affinities"
          width="85%"
          height="35px"
          fontSize="13px"
          background={COLORS.lighterGray}
          borderBottomLeftRadius="none"
          borderBottomRightRadius="none"
        />
      </Box>

      <Box
        display="flex"
        justifyContent="center"
      >
        <Stack
          ref={affinitiesListRef}
          gap="10px"
          spacing="0px"
          direction="row"
          flexWrap="wrap"
          data-name="affinityList"
          maxHeight={isMobile() ? '13svh' : '10em'}
          width="85%"
          overflowY="scroll"
          background={COLORS.lighterGray}
          padding="5px"
          borderRadius="0 0 5px 5px"
          marginTop="-16px"
        >
          { filteredAffinityList }
        </Stack>
      </Box>
    </MotionStack>
  )
}
